import { ApolloProvider as BaseApolloProvider } from '@apollo/client';
import { ReactNode } from 'react';
import { createApolloClient } from '../graphql/client';
import { useConfig } from "../utils/useConfig";
import { CircularProgress } from '@mui/material';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';

interface Props {
  children: ReactNode;
}

export const ApolloProvider = ({ children }: Props) => {
  const { config, isLoading } = useConfig();
  const { getToken } = useKindeAuth();

  if (isLoading || !config) {
    return <CircularProgress />;
  }

  const client = createApolloClient(config.GRAPHQL_URL, getToken);

  return (
    <BaseApolloProvider client={client}>
      {children}
    </BaseApolloProvider>
  );
}; 